var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hc-base-upload-readonly',{attrs:{"hcCaseMasterId":_vm.hcCaseMasterId,"hcCaseFlightFileType":_vm.hcCaseFlightFileType},on:{"downloadFile":_vm.downloadFile}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-deaa81ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminstration/khachsan/hc-ks-upload-readonly.vue
// module id = null
// module chunks = 